import prop from 'ramda/src/prop';

export default prop('className');
